import { Routes, Route, Navigate } from 'react-router-dom';
import NewHeader from '../components/common/NewHeader';
import ContactUs from 'pages/auth/contactUs/ContactUs';
import AboutUsPage from 'pages/auth/AboutUsPage/AboutUsPage';
import HomePage from '../pages/auth/HomePage/HomePage';
import PlansPage from 'pages/auth/PlansPage/PlansPage';
import OurTeam from 'pages/auth/ourTeam/OurTeam';
import SignInPage from 'pages/auth/SignInPage/SignInPage';
import ForgetPasswordPage from 'pages/auth/ForgetPasswordPage/ForgetPasswordPage';
import ResetPasswordPage from 'pages/auth/ResetPasswordPage/ResetPasswordPage';
import SignUpPage from 'pages/auth/signup/SignUpPage';
import VerifyAccountPage from 'pages/auth/VerifyAccountPage/VerifyAccountPage';
import PrivacyPage from 'pages/auth/PrivacyPage/PrivacyPage';
import TermsPage from 'pages/auth/TermsPage/TermsPage';
import AccountDeletionPage from 'pages/auth/AccountDeletionPage/AccountDeletionPage';
import GuestInvitationRedirect from 'pages/auth/GuestInvitationRedirect/GuestInvitationRedirect';
import InviteSignupPage from 'pages/auth/InviteSignupPage/InviteSignupPage';

export default function GuestRoutes() {
  return (
    <>
      <NewHeader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/plans" element={<PlansPage />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/signin" element={<SignInPage />} />
        <Route path="/signup/:planId" element={<SignUpPage />} />
        <Route path="/signup" element={<SignUpPage />} />
        <Route path="/forget-password" element={<ForgetPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verification/:token" element={<VerifyAccountPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/account-deletion" element={<AccountDeletionPage />} />
        <Route path="/invite-signup/:userId/:code/:key" element={<InviteSignupPage />} />
        <Route path="/dashboard/:userId/invitation/:code/:key" element={<GuestInvitationRedirect />} />
        <Route path="*" element={<Navigate to="/signin" replace />} />
      </Routes>
    </>
  );
}
